import React from 'react'

export default ({ title, subtitle, children}) => (
    <div className="formSectionWrapper">
        <div className="subtitle">{title}</div>
        {subtitle ? <p><i>{subtitle}</i></p> : null}
        {children}
    </div>
)
